import Vue from 'vue'
import http from '../../utils/fetch'

export default {
  state: {
    combines: [],
  },
  mutations: {
    'SAVE_COMBINES'(state, combines) {
        state.combines = combines
    }
  },
  getters: {
    getCombines(state) {
      let _combines = state.combines
      return _combines || []
    }
  },
  actions: {
    async fetchActiveCombines({state, commit}) {
      let {data} = await http.get({
        url: '/combine/list/active'
      })
      let combines = data.list
      console.info('[Fetched Combines] - ', combines)
      commit('SAVE_COMBINES', combines)
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/module/combine.js